<div class="hamburger-outer">
  <div class="hamburger-inner">
    <div class="stripe"></div>
    <div class="stripe"></div>
    <div class="stripe"></div>
  </div>
</div>
